var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.email)?_c('a',{staticClass:"underline",attrs:{"href":'mailTo:' + _vm.email,"target":"_blank"}},[_vm._v(_vm._s(_vm.email))]):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }